import { cn } from "@omni/utils/styles";

import { RatingFieldChildProps } from "../ratingField.component";

export const NumberIcon = ({ index, isActive }: RatingFieldChildProps) => {
    return (
        <svg
            aria-hidden="true"
            fill="none"
            viewBox="0 0 34 34"
            className={cn(
                "tw:absolute tw:flex tw:items-center tw:justify-center tw:top-[0.8rem]",
                "tw:left-[0.8rem] tw:h-[calc(100%-1.6rem)] tw:w-[calc(100%-1.6rem)]"
            )}
        >
            <text
                x="50%"
                y="50%"
                dominantBaseline="middle"
                textAnchor="middle"
                className={cn(
                    "tw:fill-[#ffc107] tw:text-[#ffc107] tw:text-[1.5rem]",
                    {
                        "tw:fill-white tw:text-white": isActive
                    }
                )}
            >
                {index}
            </text>
        </svg>
    );
};
